import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.scss';
import closeICone from '../../../assets/Imagess/close-white.svg';
import closeDark from '../../../assets/Imagess/close-dark.svg';
import Buttons from '../Buttons/Buttons';

const Modal = ({
  children,
  onClose,
  title,
  width,
  height,
  modalInnerContainerStyle,
  closeWhite = true,
  closeStyle,
  modalContainerStyle,
  saveButton = false,
  saveButtonTitle,
  onClickSaveButton,
  scrollY,
  noOverflow,
  innerContainerClass,
  /**
   * Close when the backdrop is clicked. OPT-IN, deliberately.
   *
   * Every modal in this CMS shares this atom, and several hold long unsaved
   * forms where a stray click outside destroying the work would be worse than
   * having no shortcut at all. Screens that want it ask for it.
   */
  closeOnBackdrop = false,
}) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) onClose();
    };

    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  // The press and the release must BOTH land on the backdrop. Without the
  // first check, selecting text inside the dialog and releasing the mouse
  // outside it counts as a backdrop click and closes the dialog mid-drag.
  const backdropPressRef = React.useRef(false);

  const handleBackdropMouseDown = (event) => {
    backdropPressRef.current = event.target === event.currentTarget;
  };

  const handleBackdropClick = (event) => {
    if (!closeOnBackdrop) return;
    if (event.target !== event.currentTarget) return;
    if (!backdropPressRef.current) return;
    backdropPressRef.current = false;
    onClose?.();
  };

  return ReactDOM.createPortal(
    <div
      className={styles['modal-container']}
      style={{ ...modalContainerStyle }}
      onMouseDown={closeOnBackdrop ? handleBackdropMouseDown : undefined}
      onClick={closeOnBackdrop ? handleBackdropClick : undefined}
    >
      <div
        style={{
          width: width,
          height: height,
          ...modalInnerContainerStyle,
          overflowY: scrollY,
        }}
        className={`${styles['modal-innerContainer']} ${innerContainerClass}`}
      >
        <>
          {title && <h2>{title}</h2>}
          {saveButton && (
            <div className={styles['save-button']}>
              <Buttons
                rounded={true}
                text={saveButtonTitle}
                handleOnClick={onClickSaveButton}
              />
            </div>
          )}

          <img
            src={closeWhite ? closeICone : closeDark}
            alt='close icon'
            className={styles['close-icon']}
            onClick={onClose}
            style={{ ...closeStyle }}
          />
        </>
        <div
          className={styles['modal-body']}
          style={{
            overflowY: noOverflow ? 'hidden' : scrollY,
          }}
        >
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
